import React, { useEffect } from "react";

const Test = ({ getState }) => {
  useEffect(() => {
    return () => {
      getState();
    };
  }, [getState]);

  return (
    <div
      style={{
        textAlign: "center",
        fontSize: 20,
        fontStyle: "italic",
        fontWeight: "500",
        letterSpacing: 0.5,
      }}
    >
      Loading...
    </div>
  );
};

export default Test;
